import { render, staticRenderFns } from "./rulerMark.vue?vue&type=template&id=8872c29e&scoped=true"
import script from "./rulerMark.vue?vue&type=script&lang=js"
export * from "./rulerMark.vue?vue&type=script&lang=js"
import style0 from "./rulerMark.vue?vue&type=style&index=0&id=8872c29e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8872c29e",
  null
  
)

export default component.exports